import * as Yup from 'yup';

import { phoneValidationSchema } from '~/common/utils/validation';

export const mobileNumberFormSchema = Yup.object().shape({
  mobileNumber: phoneValidationSchema,
});
